module.exports = __webpack_public_path__ + "static/media/dg2.95ba7a9d.jpg";